import { createSlice, PayloadAction } from "@reduxjs/toolkit";
const evaluatorDetails = createSlice({
  name: "Evaluator",
  initialState: {
    evaluatorId: "", evaluatorData: [], evaluatorSheetId: "", evaluatorSheetData: [], tempEvaluatorSheetData: {},
    apiTrigger: "", evaluationId: "", questionnaireId: "", answerId: "", evaluatorLoader: false, evaluatorUserId: 0, kpiId: "", triggerData: false
  },
  reducers: {
    setEvaluatorId: (state: any, action: PayloadAction<any>) => {
      state.evaluatorId = action.payload;
    },
    setEvaluatorData: (state: any, action: PayloadAction<any>) => {
      state.evaluatorData = action.payload;
    },
    setEvaluatorSheetData: (state: any, action: PayloadAction<any>) => {
      state.evaluatorSheetData = action.payload;
    },
    setEvaluatorSheetId: (state: any, action: PayloadAction<any>) => {
      state.evaluatorSheetId = action.payload;
    },
    setEvaluationId: (state: any, action: PayloadAction<any>) => {
      state.evaluationId = action.payload;
    },
    setEvaluatorLoader: (state: any, action: PayloadAction<any>) => {
      state.evaluatorLoader = action.payload;
    },
    setApiTrigger: (state: any, action: PayloadAction<any>) => {
      state.apiTrigger = action.payload;
    },
    setQuestionnaireId: (state: any, action: PayloadAction<any>) => {
      state.questionnaireId = action.payload;
    },
    setAnswerId: (state: any, action: PayloadAction<any>) => {
      state.answerId = action.payload;
    },
    setEvaluatorUserId: (state: any, action: PayloadAction<any>) => {
      state.evaluatorUserId = action.payload;
    },
    setTempEvaluatorSheetData: (state: any, action: PayloadAction<any>) => {
      state.tempEvaluatorSheetData = action.payload;
    },
    setTriggerData: (state: any, action: PayloadAction<any>) => {
      state.triggerData = action.payload;
    },
    setKpiId: (state: any, action: PayloadAction<any>) => {
      state.kpiId = action.payload;
    },
  },
});
export const { setEvaluatorId, setEvaluatorData, setEvaluatorSheetData, setApiTrigger, setAnswerId, setEvaluatorUserId, setKpiId,
  setEvaluatorSheetId, setEvaluationId, setEvaluatorLoader, setQuestionnaireId, setTempEvaluatorSheetData, setTriggerData } = evaluatorDetails.actions;
export default evaluatorDetails.reducer;












